import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import { type } from '@testing-library/user-event/dist/type';

let Other = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  let [count, setCount] = useState();
  let [indexs, setIndex] = useState(0);
  let [sel, setSel] = useState("All");

  let [value, inputvalue] = useState();

  let [ amount , setAmount ] = useState() 
  let [ con , setCon ] = useState()

  let [ cons , setCons ] = useState()
  let [ gst , setGst ] = useState()
  let [ total , setTotal ] = useState()

  useEffect(() => {
    Start();
    User();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
 
    // try {

    //   let pp = { aadhar: pancno, name: panname, idss: dd?._id, };

    //   let apicall = await axios({
    //     method: "post",
    //     url: Base_url + "/gst/fraudd",
    //     data: pp,
    //   })
    //     .then((dat) => {
    //       alert("Success");
    //     })
    //     .catch((ee) => {
    //       alert(" Failed");
    //     });
    // } catch (err) {
    //   alert(" Failed");
    // }
  };

  let Submit = async () => {
    let conss = amount * (con /100)
    setCons(conss)

    let ggst = conss * ( 18 /100)
    setGst(ggst)

    console.log(conss , 'conss')

    console.log(ggst , 'conss')

    let ttooo = amount + conss
    setTotal(ttooo)

  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }}>
          <div className="row" style={{ position: 'sticky', top: 0, backgroundColor: '#fff', padding: '10px' }}>
            <p style={{ fontWeight : '700' , fontSize : 25 }} >Gst Calculator</p>
          </div>
          <div className="row mb-4">
            <div className="col-5">
              <input type="text" onChange={(e)=>{ setAmount(e.target.value)}} placeholder="Enter Amount" style={{ width: '100%' }} />
            </div>
            <div className="col-5">
              <input type="text" onChange={(e)=>{ setCon(e.target.value)}} placeholder="Enter Amount" style={{ width: '100%' }} />
            </div> 
            <div className="col-2">
              <button onClick={() => {
                Submit()
              }} >Submit</button>
            </div> 
          </div>
          <p>Amount : {amount}</p>
          <p>Con Fees : {cons}</p>
          <p>Gst : {gst}</p>
          <p>Total : {total}</p>

        </div>
      </div>
    </div>
  );
};

export default Other;
